import { render, staticRenderFns } from "./ResumeInfo.vue?vue&type=template&id=d25d33b6&scoped=true"
import script from "./ResumeInfo.vue?vue&type=script&lang=js"
export * from "./ResumeInfo.vue?vue&type=script&lang=js"
import style0 from "./ResumeInfo.vue?vue&type=style&index=0&id=d25d33b6&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d25d33b6",
  null
  
)

export default component.exports